<button [disabled]="isLoading || disabled" mat-flat-button [class]="class" (click)="buttonClicked()">
  <span [fxHide]="isLoading">
    <ng-content></ng-content>
  </span>
  <mat-spinner [fxHide]="!isLoading" diameter="20"></mat-spinner>
</button>
